export default {
  name: 'popup',

  events: [
    {
      on: 'click',
      handle (e) {
        e.preventDefault()
        const target = document.querySelector(this.el.dataset.target)
        const video = target.querySelector('.video-alt')
        const clone = video.cloneNode(true)

        target.classList.toggle('is-visible')

        if (target.classList.contains('is-visible')) {
          /* eslint-disable-next-line */
          let playerAlt = new Vimeo.Player('video2', {
            id: this.el.dataset.videoId,
          })
          playerAlt.play()
          video.parentNode.insertBefore(clone, video)
        } else {
          target.querySelector('.video-alt:last-child').remove()
        }
      },
    },
  ],

  componentDidMount () {
  },
}
